import { render, staticRenderFns } from "./OrderFooterActions.vue?vue&type=template&id=307a605b"
import script from "./OrderFooterActions.vue?vue&type=script&lang=js"
export * from "./OrderFooterActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports